/* eslint-disable import/no-default-export */
/* 不要轻易 import 该函数使用，在组件中使用 this.$modal， import 容易造成循环引用，webpack 打包报错 */
import Vue from 'vue'
import store from '@/store/index'
import router from '@/router/index.js'

function $modal({
  showMask = true,
  manualShow = false,
  clickMaskToClose = true,
  switchRouteClose = true,
  switchRouteCloseWhiteList = [],
  preventTouchmove = false, // 浮层可以滚动
  maskClickHandler = 'maskClose',
  component,
  props = {},
  on = {},
  customData
}) {
  return new Promise((resolve, reject) => {
    const modal = new Vue({
      store,
      router,
      watch: {
        $route(n, o) {
          if (o && o.name == null) {
            return
          }
          if (
            switchRouteClose &&
            switchRouteCloseWhiteList.indexOf(n.name) === -1
          ) {
            this.close()
          }
        }
      },
      mounted() {
        if (customData) {
          this.$refs.subComponent = Object.assign(
            this.$refs.subComponent,
            customData
          )
        }
        if (!manualShow) {
          this.show()
        }
      },
      methods: {
        show() {
          this.$refs.mask.style.display = 'block'
          window.setTimeout(() => {
            this.$refs.mask.style.opacity = '1'
          }, 1)
        },
        close() {
          this.$refs.mask.style.opacity = '0'
          window.setTimeout(() => {
            if (this.$el.parentNode) {
              this.$el.parentNode.removeChild(this.$el)
            }
            this.$destroy()
          }, 280)
        }
      },
      render: function (createElement) {
        return createElement(
          'div',
          {
            ref: 'mask',
            class: 'modal-mask',
            style: {
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: '0',
              left: '0',
              backgroundColor: showMask ? 'rgba(0, 0, 0, 0.6)' : 'none',
              zIndex: '1000',
              opacity: '0',
              transition: 'opacity .24s ease-in-out',
              display: 'none'
            },
            on: {
              click: e => {
                if (showMask && e.target === e.currentTarget) {
                  if (
                    maskClickHandler in this.$refs.subComponent &&
                    typeof this.$refs.subComponent[maskClickHandler] ===
                      'function'
                  ) {
                    this.$refs.subComponent[maskClickHandler]()
                  }
                  if (clickMaskToClose) {
                    this.close()
                  }
                  resolve()
                }
              },
              touchmove: e => {
                if (preventTouchmove) {
                  e.preventDefault()
                }
              }
            }
          },
          [
            createElement(component, {
              ref: 'subComponent',
              props,
              on: Object.assign(on, {
                show: () => {
                  this.show()
                },
                close: () => {
                  this.close()
                }
              })
            })
          ]
        )
      },
      component: {
        modalSubComponent: component
      }
    })
    document.body.appendChild(modal.$mount().$el)
  })
}

Vue.$modal = Vue.prototype.$modal = $modal

export default $modal
